document.addEventListener('DOMContentLoaded', function () {
  // const titleElements = document.querySelectorAll('.active-slide-title');
  const bikeNameElements = document.querySelectorAll('.bike-name'); // Query bike-name elements
  const dotsContainers = document.querySelectorAll('.neon-hero-dots');
  const originalSlides = document.querySelectorAll(
    '.hero-swiper .swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)',
  );

  if (document.querySelector('.hero-swiper')) {
    const heroSwiper = new Swiper('.hero-swiper', {
      loop: true,
      speed: 800,
      spaceBetween: 100,
      pagination: {
        el: dotsContainers[0], // Target primary dots container
        clickable: true,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      on: {
        init: function () {
          updateTitle(this);
          syncDots(this);
        },
        slideChange: function () {
          updateTitle(this);
          syncDots(this);
        },
        paginationRender: function () {
          syncDots(this);
        },
        paginationUpdate: function () {
          syncDots(this);
        },
      },
    });

    function syncDots(swiper) {
      if (!dotsContainers.length) return;

      const realIndex = swiper ? swiper.realIndex : 0;
      const totalDots = originalSlides.length || 1;
      // Map active index in reverse: 0 -> 0, 1 -> total-1, 2 -> total-2, etc.
      const targetDotIndex = realIndex === 0 ? 0 : totalDots - realIndex;

      dotsContainers.forEach(function (container) {
        const bullets = container.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach(function (bullet, idx) {
          if (idx === targetDotIndex) {
            bullet.classList.add('swiper-pagination-bullet-active');
          } else {
            bullet.classList.remove('swiper-pagination-bullet-active');
          }
        });
      });

      if (dotsContainers.length > 1) {
        const primaryHtml = dotsContainers[0].innerHTML;
        dotsContainers.forEach(function (container, index) {
          if (index !== 0) {
            container.innerHTML = primaryHtml;
          }
        });
      }
    }

    function updateTitle(swiper) {
      if (!originalSlides.length) return;

      const currentSlide = originalSlides[swiper.realIndex];
      if (!currentSlide) return;

      /* 
      // Update active slide main titles
      if (titleElements.length) {
        const title = currentSlide.getAttribute('data-title');
        if (title) {
          titleElements.forEach(function (el) {
            el.textContent = title;
          });
        }
      }
      */

      // Update bike name in the h1 tag
      if (bikeNameElements.length) {
        const bikeName = currentSlide.getAttribute('data-name');
        if (bikeName) {
          bikeNameElements.forEach(function (el) {
            el.textContent = bikeName;
          });
        }
      }
    }

    dotsContainers.forEach(function (container) {
      container.addEventListener('click', function (e) {
        const bullet = e.target.closest('.swiper-pagination-bullet');
        if (!bullet) return;

        const bullets = Array.from(container.querySelectorAll('.swiper-pagination-bullet'));
        const clickedDotIndex = bullets.indexOf(bullet);
        if (clickedDotIndex === -1) return;

        const totalDots = originalSlides.length || bullets.length;
        // Re-map target slide index from clicked dot index
        const targetSlideIndex = clickedDotIndex === 0 ? 0 : totalDots - clickedDotIndex;

        const currentRealIndex = heroSwiper.realIndex;
        if (currentRealIndex === targetSlideIndex) return;

        // Calculate direct distance forward vs backward in a circular loop
        let diff = targetSlideIndex - currentRealIndex;
        if (diff > totalDots / 2) diff -= totalDots;
        if (diff < -totalDots / 2) diff += totalDots;

        // If stepping 1 position adjacent in reverse autoplay flow, trigger slidePrev() directly
        if (diff === -1 || (currentRealIndex === 0 && targetSlideIndex === totalDots - 1)) {
          heroSwiper.slidePrev(800);
        } else if (diff === 1 || (currentRealIndex === totalDots - 1 && targetSlideIndex === 0)) {
          heroSwiper.slideNext(800);
        } else {
          // Fall back to direct loop snapping for distant jumps
          heroSwiper.slideToLoop(targetSlideIndex, 800);
        }
      });
    });
  }
});
